import {FC} from 'react';
import styled from 'styled-components/macro';
import {Body2, Body4, FlexFill, Subhead3, Theme} from '../../../Components';
import {AllDatasets} from '../../../Managers/MapManager';
import {setLegendOpen} from '../../../Redux/Slices/Map';
import {useAppDispatch, useAppSelector} from '../../../store';
import {LegendBlock} from './LegendBlock';

const ColorRow = styled.div`
  flex-direction: row;
  margin: 0 0 8px;
  align-items: center;
`;

const ColorBox = styled.div`
  margin: 0 8px 0 0;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
`;

/**
 * Filters "drives" the value/onChange cycles so we can use common controls between the filters and apply them to the 1/2 datasets.
 */
export const OneDimensionDemographicLegend: FC = () => {
  const dispatch = useAppDispatch();
  const legendOpen = useAppSelector((state) => state.map.legendOpen);
  const {dataset1, dataset2} = useAppSelector((state) => state.user);
  const ds1 = AllDatasets.find((ds) => ds.id === dataset1.id);

  return (
    <LegendBlock
      legendOpen={legendOpen}
      onCloseLegend={() => dispatch(setLegendOpen(false))}
      showButton={Boolean(dataset1.id || dataset2.id)}
      onOpenLegend={() => {
        dispatch(setLegendOpen(true));
      }}>
      <Subhead3 style={{color: Theme.Colors.Neutrals._200}}>{ds1?.downloadTitle}</Subhead3>
      <Body4>{ds1?.description}</Body4>

      <Subhead3 style={{color: Theme.Colors.Neutrals._200}}>Visual Indicator</Subhead3>

      <ColorRow>
        <ColorBox style={{backgroundColor: Theme.Colors.Oranges._000}} />
        <Body2 style={{marginBottom: 0}}>Asian</Body2>
      </ColorRow>

      <ColorRow>
        <ColorBox style={{backgroundColor: Theme.Colors.Yellows._000}} />
        <Body2 style={{marginBottom: 0}}>Black</Body2>
      </ColorRow>

      <ColorRow>
        <ColorBox style={{backgroundColor: Theme.Colors.Teals._000}} />
        <Body2 style={{marginBottom: 0}}>Latinx/Hispanic</Body2>
      </ColorRow>

      <ColorRow>
        <ColorBox style={{backgroundColor: Theme.Colors.Cyans._000}} />
        <Body2 style={{marginBottom: 0}}>Native American</Body2>
      </ColorRow>

      <ColorRow>
        <ColorBox style={{backgroundColor: Theme.Colors.Blues._000}} />
        <Body2 style={{marginBottom: 0}}>Pacific Islander</Body2>
      </ColorRow>

      <ColorRow>
        <ColorBox style={{backgroundColor: Theme.Colors.Purples._000}} />
        <Body2 style={{marginBottom: 0}}>White</Body2>
      </ColorRow>

      <ColorRow>
        <ColorBox style={{backgroundColor: Theme.Colors.Pinks._000}} />
        <Body2 style={{marginBottom: 0}}>Other</Body2>
      </ColorRow>

      <FlexFill />
    </LegendBlock>
  );
};
